// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"616":"aaaef3e1","879":"c1e712d2"}[chunkId] + ".chunk.css";
};